import React, { Component } from "react";
import * as OtsUtility from "./OtsViewFunctions";
import PropTypes from 'prop-types';
import FindIt from "react/views/generic/FindIt";

import "./otsAvailabilityContent.less";

export const OtsContentRow = ({ format, available, total }) => {
	return (
		<div className="ots-data-row">
			{OtsUtility.getFormatAvailabilityText(format,available,total)}
		</div>
	);
};

class OTSPopoverContent extends Component {
	render() {
		const {featureType, uniqueId, catalogLink} = this.props;

		return (
			<div className="ots-popover-content">
				{this.props.otsData.map((rowData, index) => {
					return <OtsContentRow format={rowData.format} available={rowData.available} total={rowData.total} key={index} />;
				})}
				<div className="ots-find-it-btn-container">
					{catalogLink && <FindIt catalogLink={catalogLink} featureType={featureType} srcId={uniqueId} />}
				</div>
			</div>
		);
	}
}

OTSPopoverContent.propTypes = {
	otsData: PropTypes.array,
	featureType: PropTypes.object,
	uniqueId: PropTypes.string,
	catalogLink: PropTypes.object
}

export default OTSPopoverContent;



// WEBPACK FOOTER //
// ./src/react/views/ots/OtsAvailabilityContent.jsx